import React, { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import * as S from '../../FakturowniaInvoices/FakturowniaInvoices.styled';
import { AgreementCard, IStudent } from '../parts';

interface IAgreementsTabProps {
  student: IStudent;
  onChanged?: () => void;
}

/**
 * All agreements — active and terminated — collapsible. Same `AgreementCard`
 * as Overview but defaults all of them to closed so the page is a clean
 * list the financier can drill into. Terminated agreements get the
 * danger-toned border so chronology reads at a glance.
 */
export const AgreementsTab = memo(
  ({ student, onChanged }: IAgreementsTabProps) => {
    const { t } = useTranslation();
    const agreements = useMemo(
      () =>
        (student.agreements || []).filter((a): a is NonNullable<typeof a> =>
          Boolean(a),
        ),
      [student.agreements],
    );

    if (agreements.length === 0) {
      return (
        <S.EmptyState>
          {t('pages.studentDetail.overview.noActiveAgreements')}
        </S.EmptyState>
      );
    }

    return (
      <div style={{ marginTop: 16 }}>
        {agreements.map((a) => (
          <AgreementCard
            key={a.id}
            agreement={a}
            student={student}
            studentId={student.id}
            studentEmail={student.user?.email ?? null}
            defaultExpanded={false}
            onChanged={onChanged}
          />
        ))}
      </div>
    );
  },
);
